export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4694.3a83108f.jpg";